import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingConstant } from 'client/tracking/constant';
import { TrackingHelper } from './tracking-helper';

function getOverrides(options) {
  return TrackingHelper.getBasicDealerOptions(options);
}
const map = {
  ddp_dealer_site_clickout(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_WEBSITE_CLICKOUT,
      TrackingConstant.DEALER_SITE_CLICKOUT,
      getOverrides(options)
    );
  },

  ddp_call_dealer(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.CALL_DEALER,
      getOverrides(options)
    );
  },

  ddp_text_us(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.TEXT_DEALER,
      getOverrides(options)
    );
  },

  ddp_view_dealer_hours(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.VIEW_DEALER_HOURS,
      getOverrides(options)
    );
  },

  ddp_view_dealer_hours_and_directions(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.VIEW_DEALER_HOURS_AND_DIRECTIONS,
      getOverrides(options)
    );
  },

  ddp_view_dealer_reviews(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.VIEW_DEALER_REVIEWS,
      getOverrides(options)
    );
  },
  ddp_view_dealer_review_full(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.VIEW_DEALER_REVIEW_FULL,
      getOverrides(options)
    );
  },

  ddp_view_dealer_review_report_it(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.REPORT_IT,
      getOverrides(options)
    );
  },

  ddp_view_dealer_review_update_review(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.UPDATE_REVIEW,
      getOverrides(options)
    );
  },

  ddp_view_dealer_review_post_comment(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.POST_COMMENT,
      getOverrides(options)
    );
  },

  ddp_go_to_review_form(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_WRITE_REVIEW,
      TrackingConstant.GO_TO_REVIEW_FORM,
      getOverrides(options)
    );
  },

  ddp_view_dealer_details(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.VIEW_DEALER_DETAILS,
      getOverrides(options)
    );
  },

  ddp_view_search_result(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.VIEW_SEARCH_RESULT,
      TrackingConstant.VIEW_SEARCH_RESULT,
      getOverrides(options)
    );
  },

  ddp_other_site_clickout(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_WEBSITE_CLICKOUT,
      TrackingConstant.OTHER_SITE_CLICKOUT,
      getOverrides(options)
    );
  },
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
